import React, { useState } from 'react';
import ReactGA from 'react-ga';
import ReactPixel from 'react-facebook-pixel';
import '../styles/nav.scss';
import HamburgerMenu from 'react-hamburger-menu';
import { LINKS } from '../constants/LINKS';
import ModalComponent from './Modal';
import brand from '../assets/brand.svg';
function Nav(props) {
  const [isOpen, setOpen] = useState(false);
  const [modalIsOpen, setIsOpen] = React.useState(false);
  function openModal() {
    ReactGA.pageview('OPEN -> SignUpModal');
    ReactPixel.trackCustom('CLOSE -> SignUpModal');
    setIsOpen(true);
  }
  function closeModal() {
    setIsOpen(false);
  }

  return (
    <header className="nav-header">
      <div className="brand-container">
        <img className="logo" alt="logo" src={brand} />
      </div>
      <input type="checkbox" id="nav" className="nav-toggle" />
      <label htmlFor="nav" className="nav-toggle-label">
        <span>
          <HamburgerMenu
            menuClicked={() => setOpen(!isOpen)}
            isOpen={isOpen}
            width={25}
            height={22}
            strokeWidth={2}
            rotate={0}
            color="white"
            borderRadius={0}
            animationDuration={0.5}
          />
        </span>
      </label>
      <nav className="nav-min">
        <ul>
          <li>
            {/*eslint-disable-next-line*/}
            <a onClick={() => props.onLinkClick(LINKS.ABOUT)} href="#">
              About us
            </a>
          </li>
          <li>
            {/*eslint-disable-next-line*/}
            <a onClick={() => props.onLinkClick(LINKS.JOIN)} href="#">
              Join us
            </a>
          </li>
          <li>
            {/*eslint-disable-next-line*/}
            <a onClick={() => props.onLinkClick(LINKS.CONTACT)} href="#">
              Contact
            </a>
          </li>

          <li>
            {/*eslint-disable-next-line*/}
            <p
              onClick={() => openModal()}
              data-toggle="modal"
              data-target="#exampleModalLong"
              className="join-btn"
              href="#"
            >
              Get early access
            </p>
          </li>
        </ul>
      </nav>

      <ModalComponent closeModal={() => closeModal()} isOpen={modalIsOpen} />
    </header>
  );
}

export default Nav;
